<div class="wrapper">
  <div class="flex-container">
    <div class="logo-survey-type" [ngClass]="{'is-phone-portrait': isPhonePortrait, 'is-preview': isPreviewMode}">
      <div>
        <img src="assets/hso-logo.svg" alt="Instrument Logo" class="logo-img"
          [ngClass]="{'is-phone-portrait': isPhonePortrait}">
      </div>
      <div class="survey-type">
        <span class="info-white"
          i18n="Application title|The title of the application displayed on the header@@appTitleInHeader">Instruments
          Tool</span>
        <h1 style="display:none;">Instruments Tool</h1>
        <h2 style="display:none;">Instruments Tool</h2>
      </div>
   
      <div class="survey-menu-right">
        <!-- Progress bar -->
        <div *ngIf="showProgressInHeader && oLaunch" class="headProgress"
          [ngClass]="{'is-phone-portrait': isPhonePortrait}">
          <div class="progressCont" [hidden]="oLaunch.launchStatus === this.launchClosed || !oLaunch"
            *ngIf="!isPhonePortrait">
            <div class="progressbar-complete"
              i18n="Questionnaire Progress|Displays percentage of completeness ie 10% complete@@percentageComplete">
              {{questionnaireProgress | percent}} complete
            </div>
            <mat-progress-bar mode="determinate" color="accent"
              [value]="toPercentageNumber(questionnaireProgress)"></mat-progress-bar>
          </div>
  
          <div class="progress-spinner-box" [hidden]="oLaunch.launchStatus === this.launchClosed || !oLaunch"
            *ngIf="isPhonePortrait">
            <div class="percent-text">
              {{questionnaireProgress | percent}}
            </div>
            <div class="progress-spinner">
              <mat-progress-spinner color="accent" [diameter]="30" mode="determinate"
                [value]="toPercentageNumber(questionnaireProgress)"> </mat-progress-spinner>
            </div>
          </div>
        </div>
        <!-- Locale Select -->
        <div class="locale-select">
          <app-locale-select
            [showIcon]="true"
            [localesIds]="languagesSelected"
          />
        </div>
        <!-- Separator -->
        <span *ngIf="!isPhonePortrait"> | </span>
        <!-- FAQ -->
        <div>
          <a data-test-id="helpInfomationIcon">
            <img src="assets/help-icon.png" class="logo-img" alt="help placeholder" (click)="openRespondentFAQDoc(instrumentType)">
          </a>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="oInstrument && oLaunch" class="headerContainer"
    [ngClass]="{'is-phone-portrait': isPhonePortrait, 'is-preview': isPreviewMode}">
    <div class="headerLeft">
      <div class="orgName" [innerHTML]="oInstrument!.instrumentName! | sanitizeHtml"></div>
      <div class="subHeader">
        <span class="firstLine">
          <span>
            <img src="assets/calendar-icon.png" alt="Calendar Icon" />
          </span>
          <span>{{oLaunch.startDate | date:'medium'}}</span>
          <span>&nbsp; / &nbsp;</span>
          <span>{{oLaunch.endDate | date:'medium'}}</span>
        </span>
      </div>
    </div>
    <div class="headerRight">
      <div class="progressCont" [hidden]="oLaunch.launchStatus === this.launchClosed || !oLaunch"
        *ngIf="!isPhonePortrait">
        <div class="progressbar-complete"
          i18n="Questionnaire Progress|Displays percentage of completeness ie 10% complete@@percentageComplete">
          {{questionnaireProgress | percent}} complete
        </div>
        <mat-progress-bar mode="determinate" color="accent"
          [value]="toPercentageNumber(questionnaireProgress)"></mat-progress-bar>
      </div>
    </div>
  </div>
  <div *ngIf="oInstrument && oLaunch && isPhonePortrait" class="progress-spinner-box"
    [hidden]="oLaunch.launchStatus === this.launchClosed || !oLaunch">
    <div class="percent-text">
      {{questionnaireProgress | percent}}
    </div>
    <div class="progress-spinner">
      <mat-progress-spinner color="accent" [diameter]="30" mode="determinate"
        [value]="toPercentageNumber(questionnaireProgress)"> </mat-progress-spinner>
    </div>
  </div>
</div>